import * as React from 'react'

import { UnreachableCaseError } from 'main/util/ts'
import { UpcomingEvent, UpcomingEventType } from '../../types'
import GatheringBadge from './GatheringBadge'
import TourBadge from './TourBadge'

interface IProps {
  mapView: boolean
  upcomingEvent: UpcomingEvent
}

export default function UpcomingEventBadge({ mapView, upcomingEvent }: IProps) {
  switch (upcomingEvent.__type) {
    case UpcomingEventType.Gathering:
      return <GatheringBadge gathering={upcomingEvent.gathering} showLabel={!mapView} />
    case UpcomingEventType.Tour:
      return <TourBadge beginsAt={upcomingEvent.beginsAt} />
    default:
      throw new UnreachableCaseError(upcomingEvent)
  }
}

UpcomingEventBadge.defaultProps = {
  mapView: false,
}
